(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* === Custom predictive search JS fixes ===
     1️⃣ Clear suggestions + product count when input is cleared / X is clicked
     2️⃣ Reduce close “X” glitch by blurring on submit
     4️⃣ Make clicking on filter row tick the checkbox
  */
  document.addEventListener('DOMContentLoaded', function() {
    var predictiveSearch = document.querySelector('predictive-search');

    if (!predictiveSearch) {
      return;
    }

    var searchInputs = predictiveSearch.querySelectorAll('input[type="search"], input[name="q"]');
    var clearButtons = predictiveSearch.querySelectorAll('[data-predictive-search-clear], button[type="reset"]');
    var results = predictiveSearch.querySelector('[data-predictive-search-results]');
    var status = predictiveSearch.querySelector('[data-predictive-search-status], [data-predictive-search-live-region-count]');
    var countNode = predictiveSearch.querySelector('.predictive-search__results-count');
    var wrapper = results ? results.closest('.predictive-search') : null;
    var form = predictiveSearch.querySelector('form');

    function clearAllResults() {
      if (results) {
        results.innerHTML = '';
        results.hidden = true;
        results.setAttribute('data-cleared', 'true');
      }
      if (wrapper) {
        wrapper.classList.remove('predictive-search--visible', 'predictive-search--loading');
      }
      if (status) {
        status.textContent = '';
      }
      if (countNode) {
        countNode.textContent = '';
      }
      predictiveSearch.removeAttribute('open');
      predictiveSearch.isOpen = false;
    }

    // 1️⃣ Clear suggestions + product count when input becomes empty
    for (var i = 0; i < searchInputs.length; i++) {
      searchInputs[i].addEventListener('input', function(e) {
        if (e.target.value.trim() === '') {
          clearAllResults();
        } else if (results) {
          results.removeAttribute('data-cleared');
          results.hidden = false;
        }
      });
    }

    // Also clear after clicking the "X" (reset) button
    for (var j = 0; j < clearButtons.length; j++) {
      clearButtons[j].addEventListener('click', function() {
        window.setTimeout(function() {
          clearAllResults();
        }, 0);
      });
    }

    // 2️⃣ Reduce search button / close "X" glitch by blurring active elements on submit
    if (form) {
      var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (submitBtn) {
        submitBtn.addEventListener('click', function() {
          var active = document.activeElement;
          if (active && active !== submitBtn) {
            active.blur();
          }
        });
      }
    }

    // 4️⃣ Ensure clicking a filter row ticks the checkbox
    var filterItems = predictiveSearch.querySelectorAll('[data-filter-item], .predictive-search-filter-item');
    for (var k = 0; k < filterItems.length; k++) {
      filterItems[k].addEventListener('click', function(event) {
        // Don’t double trigger if clicking directly on checkbox/label
        var targetTag = event.target.tagName.toLowerCase();
        if (targetTag === 'input' || targetTag === 'label') {
          return;
        }

        var checkbox = this.querySelector('input[type="checkbox"]');
        if (checkbox) {
          checkbox.checked = !checkbox.checked;
          var changeEvent = new Event('change', { bubbles: true });
          checkbox.dispatchEvent(changeEvent);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
